import { ChangeDetectionStrategy, Component } from '@angular/core';

/** Root application component that serves as the top-level shell for the QIAsphere Portal. */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'qiasphere-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  // Bootstrap component declared in AppModule, so it must stay non-standalone.
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false
})
export class AppComponent {}
